module.exports = __webpack_public_path__ + "static/media/deep_focus_bar_icon.f458e472.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/deep_focus_bar_icon.png
// module id = 1992
// module chunks = 4